import React, { Component } from "react";
import Chart from "../Chart";
import DatePicker from "../DatePicker";
import { connect } from 'react-redux';
import LoadingModal from "../LoadingModal";
import { AnalyticsActions } from '../../modules/analytics';
import { CSVDownload, CSVLink } from "react-csv";

import "./styles.css";
import {
    Menu,
    Container,
    Dropdown,
    Header,
    Grid,
    Sidebar,
    Segment,
    Button,
    Divider,
    Label,
    Table,
    Tab,
    Icon,
    Loader
} from "semantic-ui-react";
import moment from "moment";
var DateRangePicker = require('react-bootstrap-daterangepicker');
const { getSalesTrend, getMetricList } = AnalyticsActions;

const metrics = [
    { key: 1, text: 'Net Sales', value: 'net_sales' },
    { key: 2, text: 'Gross Sales', value: 'gross_sales' },
    { key: 3, text: 'Total Collected', value: 'total_collected' },
    { key: 4, text: 'Discounts', value: 'discounts', },
    { key: 5, text: 'Tips', value: 'tips', },
]

// const week = ['WEEK 1','WEEK 2','WEEK 3','WEEK 4','WEEK 5','WEEK 1']
const secondary_yAxis = {
    gridLineWidth: 0,
    title: {
        text: null
    },
    opposite: true
};


const barChartTemplate = {
    chart: {
        backgroundColor: "none",
        marginLeft: 45,
        height: 382,
        fontFamily: "Roboto",
        fontWeight: 400,
        spacingTop: 10,
        type: "line",
        style: {
            paddingBottom: 10,
            fontSize: 16
        }
    },
    title: {
        useHTML: true,
        style: {
            color: "#414042",
            fontSize: 16,
            fontWeight: 400,
            fontFamily: "Roboto"
        },
        text: null,
        align: "left",
        x: -5,
        y: 5
    },
    // tooltip: {
    //     formatter: function () {
    //         let text = '<b>' + this.x + '</b> <br>'
    //             + this.series.name + ': ' + this.y + '<br>'
    //             + "Shehzad is Impatient" + '<br>'
    //         return 'text'
    //     },
    // },


    xAxis: {
        categories: [],
        labels: {
            style: {
                fontSize: "8px"
            }
        }
    },
    yAxis: [
        {
            title: {
                text: null
            }
        }
    ],
    legend: {
        itemStyle: {
            fontWeight: "400",
            fontSize: "13px",
            fontFamily: "Roboto",
            color: "#414042"
        }
    },
    labels: {
        items: []
    },
    series: [],
    credits: {
        enabled: false
    }
};
const days = ['SUN', 'MON', 'TUES', 'WED', 'THU', 'FRI', 'SAT']

const colorsForWeeklyTrends =
    [{
        linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1,
        },
        stops: [[0, "#ff799a"], [1, "#f8c282"],]
    },
    {
        linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1,
        },
        stops: [[0, "#6ddcb8"], [1, "#55b8f2"],]
    },
    {
        linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1,
        },
        stops: [[0, "#d075fd"], [1, "#fc81bd"],]
    },
    {
        linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1,
        },
        stops: [[0, "#1fb3d2"], [1, "#4362dd"],]
    },
    {
        linearGradient: {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: 1,
        },
        stops: [[0, "#f1aa3f"], [1, "#ffb91b"],]
    },

    ]
const colorsForDailyTrends =
{
    linearGradient: {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1,
    },
    stops: [[0, "#ff799a"], [1, "#f8c282"],]
}
const morning_shift = {
    linearGradient: {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1,
    },
    stops: [[0, "#937fe9"], [1, "#05c9ce"],]
}
const evening_shift = {
    linearGradient: {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1,
    },
    stops: [[0, "#fbe268"], [1, "#ffc662"],]
}

const colorsForAvgTrends =
    [
        {
            linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
            },
            stops: [[0, "#599ff7"], [1, "#875cf6"],]
        },
        {
            linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
            },
            stops: [[0, "#a0d167"], [1, "#33feb2"],]
        },
        {
            linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
            },
            stops: [[0, "#fec648"], [1, "#ffd95a"],]
        }
    ]
const legendsForAvgTrends = ['Weekday Avg', 'Weekend Avg', 'Weekly Avg']
class SalesTrend extends Component {
    onLogout() {
        this.props.authOnLogout();
    }
    constructor(props) {
        super(props);

        this.state = {
            startDate: moment().subtract(30, 'days'),
            endDate: moment().subtract(1, 'days'),
            submitBtnLoader: false,
            dailyTrends: [],
            weeklyTrends: [],
            avgTrends: [],
            metrics: [],
            selectedMetric: '',
            data: false

        };
        this.handleMetricChange = this.handleMetricChange.bind(this)
        this.handleDatePicker = this.handleDatePicker.bind(this)
        this.submitBtn = this.submitBtn.bind(this)
        this.getCategories = this.getCategories.bind(this)
        this.getSeries = this.getSeries.bind(this)
        this.dailyTrends = this.dailyTrends.bind(this)
        this.weeklyTrends = this.weeklyTrends.bind(this)
        this.avgTrends = this.avgTrends.bind(this)
        this.getFileName = this.getFileName.bind(this)
        this.getLocationName = this.getLocationName.bind(this)
        this.getMetricName = this.getMetricName.bind(this)

    }
    componentWillMount() {
        this.props.dispatch(getMetricList()).then(res => {
            let metricObj = res.data.find(ele => ele.value === 'net_sales')
            this.setState({
                metrics: res.data,
                // selectedMetric: res.data[0].value
                selectedMetric: metricObj.value

            })
            console.log(res, "RES")
        })
    }

    handleMetricChange(e, { value }) {
        console.log('value: ', value)
        this.setState({ selectedMetric: value })
    }

    handleDatePicker(event, picker) {
        if (event.type === "hide") {
            if (picker.startDate.format('YYYY-MM-DD') === picker.oldStartDate.format('YYYY-MM-DD') && picker.endDate.format('YYYY-MM-DD') == picker.oldEndDate.format('YYYY-MM-DD'))
                return false;
            this.setState({ 'startDate': picker.startDate });
            this.setState({ 'endDate': picker.endDate });
        }
    }
    getFileName(metricType) {
        let type = '';
        switch (metricType) {
            case 'dailyTrends':
                type = 'Daily'
                break;
            case 'weeklyTrends':
                type = 'Weekly'
                break;
            case 'avgTrends':
                type = 'Average'
                break;

        }
        let metricObj = this.state.metrics.find(ele => ele.value === this.state.selectedMetric)

        return `${this.getLocationName()}-${metricObj.text}(${type})-${this.state.startDate.format('YYYY-MM-DD')}-${this.state.endDate.format('YYYY-MM-DD')}.csv`
    }
    // TODO for multiple locations
    getLocationName() {

        if (this.props.filters.selectedLocations.length) {
            return this.props.filters.selectedLocations[0]
        }
        else {
            return this.props.locations
        }
    }
    getMetricName() {

    }
    submitBtn() {
        this.setState({ submitBtnLoader: true })
        this.props.dispatch(getSalesTrend({
            'start_date': this.state.startDate.format('YYYY-MM-DD'),
            'end_date': this.state.endDate.format('YYYY-MM-DD'),
            'metrics': [this.state.selectedMetric]
        })).then(res => {
            this.dailyTrends();
            this.weeklyTrends();
            this.avgTrends();
            this.setState({ submitBtnLoader: false, data: true })
        })
    }
    dailyTrends() {
        const dailyTrends = JSON.parse(JSON.stringify(barChartTemplate));
        dailyTrends["xAxis"]["categories"] = this.getCategories('dailyTrends');
        dailyTrends["series"] = this.getSeries('dailyTrends');
        // salesTrend["yAxis"].push(secondary_yAxis);
        this.setState({
            // submitBtnLoader: false,
            dailyTrends
        })
    }
    getCategories(type) {
        let trendingData = this.props.trending_data
        let categories = [];
        let noOfDays = trendingData.length;
        // let weeks = Math.ceil(noOfDays / 7);
        let weeks = Math.ceil((noOfDays + new Date(trendingData[0].date).getDay()) / 7)

        // console.log(this.props, 'this.props.trending_data')
        switch (type) {
            case 'dailyTrends':
                for (var i = 0; i < trendingData.length; i++) {
                    categories.push(trendingData[i].date)
                }
                return categories;
            case 'weeklyTrends':
                for (var i = 0; i < days.length; i++) {
                    categories.push(days[i])
                }
                return categories;
            case 'avgTrends':
                for (var i = 0; i < weeks; i++) {
                    categories.push(`Week ${(i + 1)}`)
                }
                return categories;
        }
    }
    getSeries(type) {
        let trendingData = this.props.trending_data || [];
        let noOfDays = trendingData.length;
        // let weeks = Math.ceil(noOfDays / 7);
        var noOfWeeks;
        switch (type) {
            case 'dailyTrends':
                let data = []
                let morning_shift_data = []
                let evening_shift_data = []

                // let data = []
                for (var i = 0; i < trendingData.length; i++) {
                    data.push(trendingData[i][this.state.selectedMetric])
                    morning_shift_data.push(Object.keys(trendingData[i].morning_shift).length > 0 ? trendingData[i]['morning_shift'][this.state.selectedMetric] : null)
                    evening_shift_data.push(Object.keys(trendingData[i].evening_shift).length > 0 ? trendingData[i]['evening_shift'][this.state.selectedMetric] : null)

                }

                // console.log(morning_shift_data, 'morning_shift_data')
                // console.log(evening_shift_data, 'evening_shift_data')



                let metricObj = this.state.metrics.find(ele => ele.value === this.state.selectedMetric)

                return [{
                    data,
                    color: colorsForDailyTrends,
                    name: metricObj.text,
                    showInLegend: true,
                    type: 'column',
                    yAxis: 0
                },
                {
                    data: morning_shift_data,
                    color: morning_shift,
                    name: 'Morning Shift',
                    showInLegend: true,
                    type: 'column',
                    yAxis: 0
                }, {
                    data: evening_shift_data,
                    color: evening_shift,
                    name: 'Evening Shift',
                    showInLegend: true,
                    type: 'column',
                    yAxis: 0
                }
                ];

            case 'weeklyTrends':
                data = []
                let mon = []
                let tues = []
                let wed = []
                let thu = []
                let fri = []
                let sat = []
                let sun = []

                // console.log(weeks, "weeks")(
                if (trendingData.length > 0) {
                    let day = new Date(trendingData[0].date).getDay();
                    // console.log(day, "DAY")
                    // console.log(noOfDays, "noOfDays")

                    noOfWeeks = Math.ceil((noOfDays + day) / 7)
                    // console.log(noOfWeeks, "noOfWeeks")

                    if (day != 0) {
                        for (var i = 0; i < day; i++) {
                            //    [days[i]]
                            let dayName = days[i];
                            if (dayName === 'MON') {
                                mon.push(0)
                            }
                            else if (dayName === 'TUES') {
                                tues.push(0)
                            }
                            else if (dayName === 'WED') {
                                wed.push(0)
                            }
                            else if (dayName === 'THU') {
                                thu.push(0)
                            }
                            else if (dayName === 'FRI') {
                                fri.push(0)
                            }
                            else if (dayName === 'SAT') {
                                sat.push(0)
                            }
                            else if (dayName === 'SUN') {
                                sun.push(0)
                            }

                        }
                    }
                }

                for (var i = 0; i < trendingData.length; i++) {
                    let dayName = days[new Date(trendingData[i].date).getDay()];
                    if (dayName === 'MON') {
                        mon.push(trendingData[i])
                    }
                    else if (dayName === 'TUES') {
                        tues.push(trendingData[i])
                    }
                    else if (dayName === 'WED') {
                        wed.push(trendingData[i])
                    }
                    else if (dayName === 'THU') {
                        thu.push(trendingData[i])
                    }
                    else if (dayName === 'FRI') {
                        fri.push(trendingData[i])
                    }
                    else if (dayName === 'SAT') {
                        sat.push(trendingData[i])
                    }
                    else if (dayName === 'SUN') {
                        sun.push(trendingData[i])
                    }
                }

                let weeklyData = [];
                for (var i = 0; i < noOfWeeks; i++) {
                    data = []

                    data.push(sun[i] ? parseFloat(sun[i][this.state.selectedMetric].toFixed(2)) : 0)
                    data.push(mon[i] ? parseFloat(mon[i][this.state.selectedMetric].toFixed(2)) : 0)
                    data.push(tues[i] ? parseFloat(tues[i][this.state.selectedMetric].toFixed(2)) : 0)
                    data.push(wed[i] ? parseFloat(wed[i][this.state.selectedMetric].toFixed(2)) : 0)
                    data.push(thu[i] ? parseFloat(thu[i][this.state.selectedMetric].toFixed(2)) : 0)
                    data.push(fri[i] ? parseFloat(fri[i][this.state.selectedMetric].toFixed(2)) : 0)
                    data.push(sat[i] ? parseFloat(sat[i][this.state.selectedMetric].toFixed(2)) : 0)
                    weeklyData.push({
                        data,
                        color: colorsForWeeklyTrends[i],
                        name: 'Week ' + (i + 1),
                        showInLegend: true,
                        type: 'column',
                        yAxis: 0,
                        extraData: 'aaaa'
                    })

                }
                // console.log('weeklydata by shehzad', weeklyData)
                return weeklyData;

            case 'avgTrends':
                let avgData = []
                let weekday = [];
                let weekend = [];
                let wholeWeek = [];
                let weekDayData = []
                let weekEndData = []
                let wholeWeekData = [];
                let weekDayDataAvg = []
                let weekendDataAvg = []

                let wholeWeekDayDataAvg = []

                let sum = 0;
                let avgWeekDay = [];
                let avgWeekendDay = [];
                let avgWholeWeek = []
                let avgWeekly = 0;
                // console.log('trending data: ', trendingData)


                let weekData = [];
                let tempWeek = {
                    weekDay: [],
                    weekEnd: []
                }
                for (var i = 0; i < trendingData.length; i++) {
                    noOfWeeks = Math.ceil((noOfDays + new Date(trendingData[i].date).getDay()) / 7)
                    let dayName = days[new Date(trendingData[i].date).getDay()];
                    if (dayName === 'MON') {
                        // let obj = JSON.parse(JSON.stringify(tempWeek))
                        if (i != 0) weekData.push(JSON.parse(JSON.stringify(tempWeek)))
                        tempWeek.weekDay = [];
                        tempWeek.weekEnd = [];
                        tempWeek.weekDay.push(trendingData[i])
                    }
                    else if (dayName === 'TUES' || dayName === 'WED' || dayName === 'THU' || dayName === 'FRI') {
                        tempWeek.weekDay.push(trendingData[i])
                    }
                    else if (dayName === 'SAT' || dayName === 'SUN') {
                        tempWeek.weekEnd.push(trendingData[i])
                    }
                    if (i === trendingData.length - 1) weekData.push(JSON.parse(JSON.stringify(tempWeek)))
                }

                let weekday_sum = 0
                let weekend_sum = 0
                // console.log(weekData, 'weekData')
                for (var i = 0; i < weekData.length; i++) {
                    weekday_sum = 0
                    for (var j = 0; j < weekData[i]['weekDay'].length; j++) {
                        weekday_sum += weekData[i].weekDay[j][this.state.selectedMetric]
                    }
                    weekData[i]['weekDay'].length ?
                        avgWeekDay.push(weekday_sum / weekData[i]['weekDay'].length) : avgWeekDay.push(0)

                    weekend_sum = 0;
                    for (var k = 0; k < weekData[i]['weekEnd'].length; k++) {
                        weekend_sum += weekData[i].weekEnd[k][this.state.selectedMetric]

                    }
                    weekData[i]['weekEnd'].length ?
                        avgWeekendDay.push(weekend_sum / weekData[i]['weekEnd'].length) : avgWeekendDay.push(0)

                    let total_days = weekData[i]['weekDay'].length + weekData[i]['weekEnd'].length
                    total_days ? avgWholeWeek.push((weekday_sum + weekend_sum) / total_days) : avgWholeWeek.push(0)


                }


                // console.log(avgWeekDay, 'avgWeekDay')
                // console.log(avgWeekendDay, 'avgWeekendDay')
                // console.log(avgWholeWeek, 'avgWholeWeek')


                let tempData = [avgWeekDay, avgWeekendDay, avgWholeWeek]
                // let tempArray = []
                for (var i = 0; i < tempData.length; i++) {
                    let tempArray = []
                    // console.log(noOfWeeks, '---------')
                    for (var j = 0; j < noOfWeeks; j++) {
                        tempArray.push(parseFloat(tempData[i][j].toFixed(2)) || 0)
                    }
                    avgData.push({
                        data: tempArray,
                        color: colorsForAvgTrends[i],
                        name: legendsForAvgTrends[i],
                        showInLegend: true,
                        type: 'column',
                        yAxis: 0
                    })
                }

                // console.log('avgDATA: ', avgData)

                return avgData;
            // return []
        }
    }
    weeklyTrends() {
        const weeklyTrends = JSON.parse(JSON.stringify(barChartTemplate));
        weeklyTrends["xAxis"]["categories"] = this.getCategories('weeklyTrends');
        weeklyTrends["series"] = this.getSeries('weeklyTrends');
        // weeklyTrends["yAxis"].push(secondary_yAxis);

        this.setState({
            // submitBtnLoader: false,
            weeklyTrends
        })
    }


    avgTrends() {
        const avgTrends = JSON.parse(JSON.stringify(barChartTemplate));
        avgTrends["xAxis"]["categories"] = this.getCategories('avgTrends');
        avgTrends["series"] = this.getSeries('avgTrends');
        this.setState({
            // submitBtnLoader: false,
            avgTrends
        })
    }



    render() {
        // console.log(this.props, 'this.props++++++++++')
        // console.log("dailyTrends: ", this.state.dailyTrends)
        // console.log("weeklyTrends: ", this.state.weeklyTrends)
        // console.log("avgTrends: ", this.state.avgTrends)
        const { sales_trend } = this.props;

        const csvData = (metricType) => {
            let temp = [];
            // debugger;
            let arr = [];
            let date = ''
            let dailySeries = this.state.dailyTrends.series;
            let dailyCategories = this.state.dailyTrends.xAxis.categories;
            let weeklySeries = this.state.weeklyTrends.series;
            let weeklyCategories = this.state.weeklyTrends.xAxis.categories;
            let avgSeries = this.state.avgTrends.series;
            let avgCategories = this.state.avgTrends.xAxis.categories;
            let tempData = {}

            switch (metricType) {
                case 'dailyTrends':
                    tempData = {}
                    arr = []
                    // /                    console.log(tempArr, 'tempArr')
                    for (var i = 0; i < dailyCategories.length; i++) {

                        tempData.Date = dailyCategories[i];
                        //     console.log(date)
                        for (var j = 0; j < dailySeries.length; j++) {
                            tempData[dailySeries[j].name] = dailySeries[j].data[i]
                        }
                        // console.log(tempData, 'data')
                        // debugger;
                        arr.push({ ...tempData })

                    }
                    // console.log(arr, 'arr')
                    return arr
                case 'weeklyTrends':
                    tempData = {}
                    arr = []
                    // console.log(tempArr, 'tempArr')
                    for (var i = 0; i < weeklyCategories.length; i++) {
                        tempData.Day = weeklyCategories[i];
                        //     console.log(date)
                        for (var j = 0; j < weeklySeries.length; j++) {
                            tempData[weeklySeries[j].name] = weeklySeries[j].data[i]

                        }
                        arr.push({ ...tempData })

                    }
                    // console.log(arr, 'arr')
                    return arr

                case 'avgTrends':
                    tempData = {}
                    arr = []
                    // console.log(tempArr, 'tempArr')
                    for (var i = 0; i < avgCategories.length; i++) {
                        tempData.Week = avgCategories[i];
                        //     console.log(date)
                        for (var j = 0; j < avgSeries.length; j++) {
                            tempData[avgSeries[j].name] = avgSeries[j].data[i]

                        }
                        arr.push({ ...tempData })

                    }
                    // console.log(arr, 'arr')
                    return arr

            }

        };
        const getHeaders = (metricType) => {
            let headers = [];
            let tempArr = []
            let arr = []
            let dailyTrendsClone = [];
            let weeklyTrendsClone = [];
            let avgTrendsClone = [];

            switch (metricType) {
                case 'dailyTrends':
                    headers = []
                    tempArr = []
                    headers.push('Date')
                    dailyTrendsClone = [...this.state.dailyTrends.series] || []
                    // console.log(tempArr, 'tempArr')
                    for (var i = 0; i < dailyTrendsClone.length; i++) {
                        headers.push(dailyTrendsClone[i].name)
                    }

                    // console.log(headers, 'headers')



                    return headers;

                case 'weeklyTrends':
                    arr = [];
                    headers = []
                    tempArr = []
                    headers.push('Day')
                    weeklyTrendsClone = [...this.state.weeklyTrends.series] || []
                    // console.log(tempArr, 'tempArr')

                    for (var i = 0; i < weeklyTrendsClone.length; i++) {
                        headers.push(weeklyTrendsClone[i].name)
                    }
                    // console.log(headers, 'headers')


                    return headers

                case 'avgTrends':
                    arr = [];
                    tempArr = []
                    headers.push('Week')
                    avgTrendsClone = [...this.state.avgTrends.series] || []
                    // console.log(tempArr, 'tempArr')
                    for (var i = 0; i < avgTrendsClone.length; i++) {
                        headers.push(avgTrendsClone[i].name)
                    }
                    return headers

            }

        }
        return (
            <div>
                {/* <Grid.Row style={{ float: "right" }}>
                </Grid.Row> */}
                <Grid padded={true} columns={3} style={{ backgroundColor: 'white' }}>
                    <Grid.Column>
                        <div style={styles.dropdownMain}>
                            <Dropdown
                                // text='Metric Type'
                                // multiple
                                options={this.state.metrics}
                                value={this.state.selectedMetric}
                                onChange={this.handleMetricChange}
                                fluid
                                search
                            >
                            </Dropdown>
                        </div>
                    </Grid.Column>

                    <Grid.Column>
                        <div style={styles.dropdownMain} >
                            <DateRangePicker
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                // ranges={this.state.ranges}
                                onEvent={this.handleDatePicker}
                            >
                                <span >
                                    {this.state.startDate.format('YYYY-MM-DD')} --  {this.state.endDate.format('YYYY-MM-DD')}
                                    <img className='dateBg' style={styles.dateIcon} src="/date_icon.png" />
                                </span>
                            </DateRangePicker>
                        </div>
                    </Grid.Column>

                    <Grid.Column>
                        <Button style={styles.btn} onClick={this.submitBtn}>
                            {this.state.submitBtnLoader ? <Loader active inverted inline='centered' style={{ color: 'white', marginTop: -10 }} /> : 'SUBMIT'}
                        </Button>
                    </Grid.Column>
                </Grid>
                {this.state.data ?
                    <div className="innersection">
                        <Header style={styles.mainHeadig} as="h3">
                            TRENDS OVERVIEW
                    </Header>

                        <Grid columns={1}>
                            <Grid.Column>
                                <div className="float-right">
                                    <CSVLink
                                        filename={this.getFileName('dailyTrends')}
                                        headers={getHeaders('dailyTrends')}
                                        target="_blank"
                                        data={csvData('dailyTrends')}
                                    // data={[]}
                                    >
                                        <Icon name="download" color="black" type="font-awesome" />
                                    </CSVLink>
                                </div>
                                <Chart title="DAILY TREND" data={this.state.dailyTrends} />
                            </Grid.Column>
                        </Grid>


                        <Grid columns={2}>
                            <Grid.Column>
                                <div className="float-right">
                                    <CSVLink
                                        filename={this.getFileName('weeklyTrends')}
                                        // headers={headers}
                                        headers={getHeaders('weeklyTrends')}
                                        target="_blank"
                                        // data={[]}
                                        data={csvData('weeklyTrends')}

                                    >
                                        <Icon name="download" color="black" type="font-awesome" />
                                    </CSVLink>
                                </div>
                                <Chart title="WEEKLY TREND" data={this.state.weeklyTrends} />
                            </Grid.Column>

                            <Grid.Column>
                                <div className="float-right">
                                    <CSVLink
                                        filename={this.getFileName('avgTrends')}
                                        headers={getHeaders('avgTrends')}
                                        // headers={headers}
                                        target="_blank"
                                        data={csvData('avgTrends')}
                                    // data={[]}
                                    >
                                        <Icon name="download" color="black" type="font-awesome" />
                                    </CSVLink>
                                </div>
                                <Chart title="AVG TREND" data={this.state.avgTrends} />
                            </Grid.Column>

                            {/* <div className="float-right">
                                <CSVLink
                                    filename="Trends"
                                    // headers={reportData.header}
                                    target="_bdivlank"
                                    // data={csvData()}
                                    data={[]}
                                >
                                    <Icon name="download" color="black" type="font-awesome" />
                                </CSVLink>
                            </div>
                            <Chart title="WEEKLY TREND" data={this.state.weeklyTrends} />
                            <Chart title="AVG TREND" data={this.state.avgTrends} /> */}
                        </Grid>
                        {/* <Grid columns={1}>
                        <Chart title="SHIFTWISE TREND" data={this.state.sales_trend_data} />
                    </Grid> */}
                        {/* <Grid columns={2}>
                        <Chart title="MONTHLY SALES TREND" data={this.state.sales_trend_data} />
                        <Chart title="QTR SALES TREND" data={this.state.sales_trend_data} />
                    </Grid> */}


                    </div> : null
                }
            </div >
        );
    }
}

const styles = {


    dropdownMain: {
        marginTop: 35,
        width: '80%',
        height: 40,
        boxShadow: '0 1px 6px rgba(0, 0, 0, 0.1)',
        paddingLeft: 10,
        paddingRight: 10,
        fontFamily: 'Roboto',
        fontSize: 14,
        fontWeight: 300,
        paddingTop: 12,
        marginLeft: 50
    },

    dateIcon: {
        float: 'right'
    },

    btn: {
        marginTop: 35,
        color: 'white',
        backgroundColor: '#9F61E7',
        fontFamily: 'Roboto',
        fontWeight: 300,
        height: 40,
        width: '60%'
    },
    mainHeadig: {
        marginTop: 30,
        fontWeight: 400,
        fontFamily: "Roboto",
        color: "#666874"
    },
    heading: {
        fontSize: 16,
        color: "rgb(102, 104, 116)",
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 20,
        display: "flex",
        justifyContent: "space-between",
        fontWeight: 400,
        textTransform: "uppercase",
        fontFamily: "Roboto"
    }

};



export default connect(() => {
    return {}
})(SalesTrend)



// WEBPACK FOOTER //
// ./src/components/Tabs/salesTrend.js